export const getKeyTitle = (key: string) => {
	const string = key.replaceAll('.', ' ').replaceAll('_', ' ')

	return string.charAt(0).toUpperCase() + string.slice(1)
}
